import { call, takeLatest } from 'redux-saga/effects';

import { BI_MODULE } from 'config/api-variables';
import { landingPageActions as actions } from '.';
import { sagaSpecialRequestTemplate } from 'utils/tools/slice-actions';

function* submitCallback({ payload }) {
  yield call(
    sagaSpecialRequestTemplate,
    BI_MODULE + '/call_back/create_mktg_all_enquiries',
    payload,
    actions,
    'updateActionEnd',
    'updateActionError',
    'There was some problem submitting your form. Please try again later!',
    'Your request was successfully submitted. Please wait while we get back!',
    [false],
  );
}

export function* landingPageSaga() {
  yield takeLatest(actions.submitCallbackStart.type, submitCallback);
}
